/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import React from 'react';
import { jsx } from 'theme-ui';
import Box from '../Grid/Box';

const tags = {
  semiTitle: 'h3',
  default: 'div',
};

/** @type {import('theme-ui').ThemeUIStyleObject} */
const nowrapStyle = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

/**
 *
 * @param {object} props
 * @param {import('./textVariants').TextVariants} [props.variant]
 * @param {any} [props.as]
 * @param {string} [props.variants] Uses another set of variants if set. Set to 'p' or 'text' for example.
 * @param {boolean} [props.lowContrast] Uses a lowContrast font variant.
 * @param {boolean} [props.nowrap] Avoids text wrapping.
 * @param {React.ReactNode} props.children The text to display.
 * @param {import('theme-ui').ThemeUIStyleObject} [props.sx] SX props to apply to the text.
 * @returns {React.ReactElement}
 */
function Text(
  {
    variant = 'default',
    as = tags[variant] || tags.default,
    variants = 'text',
    lowContrast = false,
    nowrap = false,
    children,
    sx = {},
    ...rest
  },
  ref
) {
  return (
    <Box
      as={as}
      {...rest}
      sx={{
        ...sx,
        variant: `${variants}.${variant}`,
        fontWeight: lowContrast ? 'lowContrast' : undefined,
        ...(nowrap && nowrapStyle),
      }}
      ref={ref}
    >
      {children}
    </Box>
  );
}

export default React.forwardRef(Text);
